import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { CheckCircle2, MessageCircle, Link2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import RemindSheet from "@/components/RemindSheet";
import AckSheet from "@/components/AckSheet";
import api from "@/lib/api";
import { fmtNaira, fmtDate, isIOwe } from "@/lib/format";

export default function DebtSuccess() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [remind, setRemind] = useState(false);
  const [ack, setAck] = useState(false);
  const { data: debt } = useQuery({
    queryKey: ["debt", id],
    queryFn: async () => (await api.get(`/debts/${id}`)).data,
  });

  if (!debt) return <div className="debii-shell" />;

  const iOwe = isIOwe(debt);

  return (
    <div className="debii-shell min-h-screen flex flex-col px-6 py-12">
      <div className="flex-1 flex flex-col justify-center text-center">
        <div className="mx-auto h-20 w-20 rounded-full bg-emerald-100 flex items-center justify-center animate-pop">
          <CheckCircle2 className="h-11 w-11 text-emerald-700" strokeWidth={2} />
        </div>
        <h1 className="mt-6 font-display text-2xl font-bold text-foreground">Record saved ✓</h1>
        <p className="mt-3 text-lg text-foreground">
          {iOwe ? (
            <>You owe <span className="font-semibold">{debt.person_name}</span>{" "}<span className="font-display font-bold">{fmtNaira(debt.outstanding_amount, debt.currency)}</span></>
          ) : (
            <><span className="font-semibold">{debt.person_name}</span> owes you{" "}<span className="font-display font-bold">{fmtNaira(debt.outstanding_amount, debt.currency)}</span></>
          )}
        </p>
        {debt.due_date && <p className="mt-1 text-sm text-muted-foreground">Due {fmtDate(debt.due_date)}</p>}

        <div className="mt-10 space-y-3">
          <Button data-testid="success-ask-ack" onClick={() => setAck(true)} className="w-full h-12 rounded-xl text-base">
            <Link2 className="h-5 w-5" /> Ask {debt.person_name} to {iOwe ? "confirm" : "acknowledge"}
          </Button>
          {!iOwe && (
            <Button data-testid="success-send-reminder" variant="outline" onClick={() => setRemind(true)} className="w-full h-12 rounded-xl text-base">
              <MessageCircle className="h-5 w-5" /> Send a reminder
            </Button>
          )}
          <Button data-testid="success-done" variant="ghost" onClick={() => navigate("/")} className="w-full h-11 rounded-xl">
            Done
          </Button>
        </div>
      </div>

      <RemindSheet open={remind} onOpenChange={setRemind} debt={debt} />
      <AckSheet open={ack} onOpenChange={setAck} debt={debt} />
    </div>
  );
}
